module.exports = __webpack_public_path__ + "media/images/trash-e4a87173d910eaa48405dfd1ed6076e7.png";